import { useCandidateSession } from '../context/CandidateSessionContext';
import { useCandidateVerificationMutations } from './useCandidateVerificationMutations';
import type { CandidateVerificationMutations } from './useCandidateVerificationMutations';

export function useCandidateVerificationActions(
  experienceId: string
): CandidateVerificationMutations {
  const { isAnonymous, shareId } = useCandidateSession();
  const queryKey = isAnonymous
    ? ['candidate-verifications', 'anonymous', shareId, experienceId]
    : ['candidate-verifications', experienceId];

  return useCandidateVerificationMutations({
    queryKey,
    isAnonymous,
    shareId,
    experienceId,
  });
}
